<template>
    <div class="accountManage">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="content">
            <van-cell title="头像" is-link>
                <div class="img" @click="onChangeFace">
                    <img :src="avatarUrl" alt="">
                    <!-- <img src="../../../assets/img/b2b/b1.jpg" alt=""> -->
                </div>
            </van-cell>
            <van-cell title="姓名" is-link><div class="setting" @click="onName" v-text="userInfo.name ? userInfo.name : '未设置'"></div></van-cell>
            <van-cell title="绑定手机" @click="onPhone" is-link><span v-text="phone"></span></van-cell>
            <van-cell title="登录密码" @click="onPass" is-link><span v-text="userInfo.isInitPassword ? '默认密码' : '******'"></span> </van-cell>
            <van-cell
                v-if="userInfo.isAdmin"
                title="钱包支付密码"
                label="(用于活动预充和钱包支付)"
                @click="onPricePass"
                is-link>
                <span v-text="!userInfo.isSetPayPassword ? '设置密码' : '修改密码'"></span>
            </van-cell>
        </div>
    </div>
</template>
<script>
import Header from '../../common/header'
import { versions } from '../../common/version'
import { mapActions } from 'vuex'
import { Toast } from 'vant'
export default {
    name: 'accountManage',
    components: {
        Header
    },
    data () {
        return {
            title: '账号管理',
            userInfo: '',
            phone: '',
            avatarUrl: require('../../../assets/img/b2b/head@2x.png')
        }
    },
    methods: {
        ...mapActions(['getUserInfoData', 'updateAvatar']),
        onBack () {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'back'
                })
            } else {
                window.kfxt.back()
            }
        },
        onName () {
            this.$router.push({ path: '/b2b/accountManage/editName' })
        },
        onPhone () {
            this.$router.push({ path: '/b2b/accountManage/editPhone' })
        },
        onPass () {
            this.$router.push({ path: '/b2b/accountManage/editPassword' })
        },
        onPricePass () {
            if (this.userInfo.isSetPayPassword) {
                this.$router.push({ path: '/b2b/payCode/editPayCode' })
            } else {
                this.$router.push({ path: '/b2b/payCode/setPayCode' })
            }
        },
        onChangeFace () {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhoto',
                    'target': 'HEADERIMG'
                })
            } else {
                window.kfxt.callPhoto('HEADERIMG')
            }
        },
        getOEImgUrl (tag, url) {
            if (tag == 'HEADERIMG') {
                this.avatarUrl = url
                this.headImg()
            }
        },
        phoneNumFilter () {
            // 1字符串转化成数组
            let phoneArr = this.userInfo.phone.split('')
            let phoneStr = ''
            // 2.将数组中的4-9位变成*
            phoneArr.map((res, index) => {
                if (index > 2 && index < 9) {
                    phoneStr += '*'
                } else {
                    phoneStr += res
                }
            })
            this.phone = phoneStr
        },
        async headImg (url) {
            await this.updateAvatar({
                avatarUrl: this.avatarUrl
            }).then(async (data) => {
                Toast('头像修改成功')
                await this.getUserInfoData()
            })
        },
        async init () {
            await this.getUserInfoData()
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            this.phoneNumFilter()
            if (this.userInfo.avatarUrl) {
                this.avatarUrl = this.userInfo.avatarUrl
            }
        }
    },
    mounted () {
        window.getOEImgUrl = (tag, url) => {
            this.getOEImgUrl(tag, url)
        }
        this.init()
    }
}
</script>
<style lang="scss" scoped>
    .accountManage{
        .content{
            font-size: 32px;
            color: #000000;
            padding-left: 32px;
            background: #ffffff;
        }
    }
    .img{
        position: relative;
        top: -20px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    .name{
        width: 416px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        white-space: normal;
        word-break: break-all;
    }
    .setting {
        width: 400px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    /deep/ .van-cell__title{
        color: #000000;
    }
    /deep/ .van-cell{
        padding: 42px 0;
        line-height: initial;
    }
    /deep/ .van-cell__value{
        flex: 0 0 416px;
        line-height: initial;
        height: auto;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: initial;
        white-space: normal;
        word-break: break-all;
        color: #676767;
        position: absolute;
        right: 50px;
    }
    /deep/ .van-cell__right-icon{
        width: 40px;
        height: 40px;
        line-height: 40px;
        top: 4px;
    }
    /deep/ .van-cell__label{
        font-size: 24px;
        line-height: 30px;
    }
</style>